/**
 * Funciones para validación de RUT chileno
 */

const RutValidator = {
  /**
   * Valida si un RUT es válido según el dígito verificador
   * @param {string} rutCompleto - RUT en formato: "12345678-k" o "12345678k"
   * @returns {boolean} - true si el RUT es válido, false en caso contrario
   */
  validaRut: function (rutCompleto) {
    rutCompleto = rutCompleto.replace(/^0+|[^0-9kK-]+/g, '');
    if (!/^[0-9]+-[0-9kK]{1}$/.test(rutCompleto)) return false;
    const tmp = rutCompleto.split('-');
    const digv = tmp[1].toLowerCase();
    const rut = tmp[0];
    return (this.dv(rut) === digv);
  },

  /**
   * Calcula el dígito verificador de un RUT
   * @param {string|number} T - Número de RUT sin dígito verificador
   * @returns {string} - Dígito verificador (0-9 o 'k')
   */
  dv: function (T) {
    let M = 0, S = 1;
    for (; T; T = Math.floor(T / 10)) {
      S = (S + T % 10 * (9 - M++ % 6)) % 11;
    }
    return S ? String(S - 1) : 'k';
  },

  /**
   * Formatea un RUT separado en número y dígito verificador
   * @param {string|number} rut - Número de RUT
   * @param {string|number} dv - Dígito verificador
   * @returns {string} - RUT formateado: "12345678-k"
   */
  formatRut: function (rut, dv) {
    if (!rut || !dv) return '';
    return `${rut}-${dv}`.toLowerCase();
  }
};

export default RutValidator;
